<template>
  <div class="widget_container fr-grid-row" :id="widgetId">
    <div class="r_col fr-col-12">
      <div class="chart">
        <div class="linechart_tooltip">
          <div class="tooltip_header"></div>
          <div class="tooltip_body">
            <div class="tooltip_value">
              <span class="tooltip_dot"></span>
            </div>
          </div>
        </div>
        <canvas :id="chartId"></canvas>
        
        <!-- Legend row -->
        <div class="fr-mt-3v legend-row" :style="legendMarginStyle">
          <div v-for="(item, index) in nameParse" :key="item" class="flex legend-item" @click="ChangeShowLine(index)">
            <span class="legende_dot" v-bind:style="{'background-color': colorParse[index], 'opacity': opacity[index]}"></span>
            <p class='fr-text--sm fr-text--bold fr-ml-1w fr-mb-0' :style="{'opacity': opacity[index]}">
              {{capitalize(nameParse[index])}}
            </p>
          </div>
          
          <div v-for="(item2, index2) in hlineNameParse" :key="item2" class="flex legend-item">
            <span class="legende_dash_line1" v-bind:style="{'background-color': hlineColorParse[index2]}"></span>
            <span class="legende_dash_line2" v-bind:style="{'background-color': hlineColorParse[index2]}"></span>
            <p class="fr-text--sm fr-text--bold fr-ml-1w fr-mb-0">{{ capitalize(hlineNameParse[index2]) }}</p>
          </div>
          
          <div v-for="(item3, index3) in vlineNameParse" :key="item3" class="flex legend-item">
            <span class="legende_dash_line1" v-bind:style="{'background-color': vlineColorParse[index3]}"></span>
            <span class="legende_dash_line2" v-bind:style="{'background-color': vlineColorParse[index3]}"></span>
            <p class="fr-text--sm fr-text--bold fr-ml-1w fr-mb-0">{{ capitalize(vlineNameParse[index3]) }}</p>
          </div>
        </div>
        
        <div v-if="date!==undefined" class="flex fr-mt-1w" :style="legendMarginStyle">
          <p class="fr-text--xs">Mise à jour : {{date}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Chart } from 'chart.js'
import { mixin } from '@/utils.js'
import { TREND_LINE_END_YEAR } from '@/services/csvDataService.js'
import { resolvePrimaryBarToken, getFallbackPrimaryBarToken } from '@/services/chartColorTestOverrides.js'
export default {
  name: 'MultiLineChart',
  mixins: [mixin],
  data () {
    return {
      widgetId: '',
      chartId: '',
      legendLeftMargin: 100,
      display: '',
      datasets: [],
      xAxisType: 'category',
      labels: undefined,
      opacity: [1, 1],
      showLine: [],
      xparse: [],
      yparse: [],
      nameParse: [],
      tmpColorParse: [],
      colorParse: [],
      listColors: [],
      vlineParse: [],
      vlineColorParse: [],
      tmpVlineColorParse: [],
      vlineNameParse: [],
      hlineParse: [],
      hlineColorParse: [],
      tmpHlineColorParse: [],
      hlineNameParse: [],
      ymax: 0,
      pointOpacityParse: [],
      trendBySeries: [],
      hasTarget: false,
      colorPrecisionBar: '#161616',
      colorHover: [],
      viewportSmall: false
    }
  },
  props: {
    x: {
      type: String,
      required: true
    },
    y: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: undefined
    },
    color: {
      type: String,
      default: undefined
    },
    vline: {
      type: String,
      default: undefined
    },
    vlinecolor: {
      type: String,
      default: undefined
    },
    vlinename: {
      type: String,
      default: undefined
    },
    hline: {
      type: String,
      default: undefined
    },
    hlinecolor: {
      type: String,
      default: undefined
    },
    hlinename: {
      type: String,
      default: undefined
    },
    date: {
      type: String,
      default: undefined
    },
    aspectratio: {
      type: Number,
      default: 2
    },
    formatdate: {
      type: Boolean,
      default: false
      },
      pointopacity: {
        type: String,
        default: undefined
      },
      pointRadius: {
        type: Number,
        default: 4
      },
      axisFontSize: {
        type: Number,
        default: 12
      },
    isSmall: {
      type: Boolean,
      default: false
    },
    targetOverlay: {
      type: Boolean,
      default: undefined
    },
    trendBySeriesJson: {
      type: String,
      default: undefined
    }
  },
  watch: {
    y () {
      this.resetData()
      this.createChart()
    },
    color () {
      this.resetData()
      this.createChart()
    }
  },
  computed: {
    overlayHasTarget () {
      return this.targetOverlay
    },
    overlayTrendBySeries () {
      if (this.trendBySeriesJson === undefined || this.trendBySeriesJson === null || this.trendBySeriesJson === '') {
        return null
      }
      try {
        const parsed = JSON.parse(this.trendBySeriesJson)
        return Array.isArray(parsed) ? parsed : null
      } catch (e) {
        return null
      }
    },
    effectiveIsSmall () {
      return this.isSmall === true ? true : this.viewportSmall
    },
    legendMarginStyle () {
      const px = Math.max(0, Number(this.legendLeftMargin) || 0)
      return { marginLeft: px + 'px' }
    }
  },
  methods: {
    resetData () {
      this.legendLeftMargin = 100
      this.display = ''
      this.datasets = []
      this.xAxisType = ''
      this.labels = undefined
      this.opacity = []
      this.showLine = []
      this.xparse = []
      this.yparse = []
      this.nameParse = []
      this.tmpColorParse = []
      this.colorParse = []
      this.listColors = []
      this.vlineParse = []
      this.vlineColorParse = []
      this.tmpVlineColorParse = []
      this.vlineNameParse = []
      this.hlineParse = []
      this.hlineColorParse = []
      this.tmpHlineColorParse = []
      this.hlineNameParse = []
      this.ymax = 0
      this.colorPrecisionBar = ''
      this.colorHover = []
      this.trendBySeries = []
      this.hasTarget = false
    },
    computeLinearRegression (xValues, yValues) {
      if (!Array.isArray(xValues) || !Array.isArray(yValues) || xValues.length !== yValues.length || xValues.length < 2) return null
      const n = xValues.length
      const sumX = xValues.reduce((sum, v) => sum + v, 0)
      const sumY = yValues.reduce((sum, v) => sum + v, 0)
      const sumXY = xValues.reduce((sum, v, i) => sum + v * yValues[i], 0)
      const sumXX = xValues.reduce((sum, v) => sum + v * v, 0)
      const denominator = (n * sumXX) - (sumX * sumX)
      if (denominator === 0) return null
      const slope = ((n * sumXY) - (sumX * sumY)) / denominator
      const intercept = (sumY - (slope * sumX)) / n
      return { slope, intercept }
    },
    computeTrendSeriesForIndex (seriesIndex, years, values, alphaByIndex, numYears = 3) {
      // Trend based on last measured points (alpha >= 1), projected until TREND_LINE_END_YEAR.
      if (!Array.isArray(years) || !Array.isArray(values) || years.length !== values.length) return null
      const measured = []
      for (let i = 0; i < years.length; i++) {
        const raw = values[i]
        if (raw === null || raw === undefined || raw === '') continue
        const y = Number(raw)
        if (Number.isNaN(y)) continue
        const a = (alphaByIndex && alphaByIndex[i] !== undefined) ? Number(alphaByIndex[i]) : 1
        if (a < 1) continue
        const yr = Number(years[i])
        if (Number.isNaN(yr)) continue
        measured.push({ index: i, year: yr, value: y })
      }
      if (measured.length < 2) return null
      const lastMeasured = measured.slice(-numYears)
      const reg = this.computeLinearRegression(lastMeasured.map(p => p.year), lastMeasured.map(p => p.value))
      if (!reg) return null
      const firstIndex = lastMeasured[0].index
      return years.map((year, i) => {
        if (i < firstIndex) return null
        const yr = Number(year)
        if (Number.isNaN(yr)) return null
        if (yr > TREND_LINE_END_YEAR) return null
        return reg.slope * yr + reg.intercept
      })
    },
    getData () {
      const self = this
      // Récupération des paramètres
      this.listColors = this.getAllColors()
      this.xparse = JSON.parse(this.x)
      this.yparse = JSON.parse(this.y)
      if (this.pointopacity !== undefined) {
        try { this.pointOpacityParse = JSON.parse(this.pointopacity) } catch (e) { this.pointOpacityParse = [] }
      } else {
        this.pointOpacityParse = []
      }

      let tmpNameParse = []
      if (this.name !== undefined) {
        tmpNameParse = JSON.parse(self.name)
      }
      if (this.color !== undefined) {
        this.tmpColorParse = JSON.parse(self.color)
      }

      this.loadColors()
      for (let i = 0; i < this.yparse.length; i++) {
        self.showLine.push(true)
        if (tmpNameParse[i] !== undefined) {
          self.nameParse.push(tmpNameParse[i])
        } else {
          self.nameParse.push('Serie' + (i + 1))
        }
      }

      // Récupération données Vline
      if (this.vline !== undefined) {
        this.vlineParse = JSON.parse(this.vline)
        let tmpVlineNameParse = []
        if (this.vlinename !== undefined) {
          tmpVlineNameParse = JSON.parse(self.vlinename)
        }
        if (this.vlinecolor !== undefined) {
          this.tmpVlineColorParse = JSON.parse(self.vlinecolor)
        }

        for (let i = 0; i < this.vlineParse.length; i++) {
          if (tmpVlineNameParse[i] !== undefined) {
            self.vlineNameParse.push(tmpVlineNameParse[i])
          } else {
            self.vlineNameParse.push('V' + (i + 1))
          }
        }
      }

      // Récupération données Hline
      if (this.hline !== undefined) {
        this.hlineParse = JSON.parse(this.hline)
        let tmpHlineNameParse = []
        if (this.hlinename !== undefined) {
          tmpHlineNameParse = JSON.parse(self.hlinename)
        }
        if (this.hlinecolor !== undefined) {
          this.tmpHlineColorParse = JSON.parse(self.hlinecolor)
        }

        for (let i = 0; i < this.hlineParse.length; i++) {
          if (tmpHlineNameParse[i] !== undefined) {
            self.hlineNameParse.push(tmpHlineNameParse[i])
          } else {
            self.hlineNameParse.push('H' + (i + 1))
          }
        }
      }

      // Formatage des données
      let data = []
      // Cas ou x est numérique
      if (typeof self.xparse[0][0] === 'number') {
        const allX = []
        self.xparse.forEach(function (xj, j) {
          const dj = []
          const xsort = xj.map((a) => a).sort((a, b) => a - b)
          xsort.forEach(function (k) {
            const index = xj.findIndex((element) => element === k)
            dj.push({
              x: k,
              y: self.yparse[j][index]
            })
            if (!allX.includes(k)) {
              allX.push(k)
            }
          })
          data.push(dj)
        })
        self.labels = undefined
        self.xAxisType = 'linear'
      } else {
        // Cas ou x est non numérique
        data = self.yparse
        self.labels = self.xparse[0]
        self.xAxisType = 'category'
      }

      // Set ymax
      self.ymax = Math.max.apply(null, self.hlineParse)

      // Tracé de la courbe + tendance
      self.trendBySeries = []
      if (self.overlayHasTarget !== undefined) {
        self.hasTarget = self.overlayHasTarget === true
      } else {
        // Trends only when target exists (heuristic: 2030 point with alpha < 1)
        try {
          const labelsOrYears = (self.xAxisType === 'linear')
            ? (Array.isArray(self.xparse?.[0]) ? self.xparse[0] : [])
            : (Array.isArray(self.labels) ? self.labels : [])
          const idx2030 = labelsOrYears.findIndex(v => String(v).trim() === '2030')
          let found = false
          if (idx2030 !== -1) {
            if (Array.isArray(self.pointOpacityParse?.[0])) {
              found = self.pointOpacityParse.some(arr => Number(arr?.[idx2030]) < 1)
            } else if (Array.isArray(self.pointOpacityParse)) {
              found = Number(self.pointOpacityParse?.[idx2030]) < 1
            }
          }
          self.hasTarget = !!found
        } catch (e) {
          self.hasTarget = false
        }
      }
      data.forEach(function (dj, j) {
        // Normalize series length to labels (category axis) to avoid misalignment / extra points
        let djNormalized = dj
        if (self.xAxisType === 'category' && Array.isArray(self.labels)) {
          const n = self.labels.length
          djNormalized = Array.from({ length: n }, (_, i) => (dj && dj[i] !== undefined ? dj[i] : null))
        }

        let alphaByIndex = Array.isArray(self.pointOpacityParse)
          ? (Array.isArray(self.pointOpacityParse[0]) ? (self.pointOpacityParse[j] || []) : self.pointOpacityParse)
          : []
        if (self.xAxisType === 'category' && Array.isArray(self.labels)) {
          const n = self.labels.length
          alphaByIndex = Array.from({ length: n }, (_, i) => (alphaByIndex && alphaByIndex[i] !== undefined ? alphaByIndex[i] : 1))
        }

        const colorPerPoint = djNormalized.map(function (_, i) {
          let alpha = self.getExtrapolationAlpha()
          if (Array.isArray(self.pointOpacityParse)) {
            if (Array.isArray(self.pointOpacityParse[0])) {
              alpha = (self.pointOpacityParse[j] && self.pointOpacityParse[j][i] !== undefined) ? self.pointOpacityParse[j][i] : self.getExtrapolationAlpha()
            } else {
              alpha = (self.pointOpacityParse[i] !== undefined) ? self.pointOpacityParse[i] : self.getExtrapolationAlpha()
            }
          }
          return self.hexToRgba(self.colorParse[j], alpha)
        })
        self.datasets.push({
          data: djNormalized,
          fill: false,
          // Make the default line fully transparent; we'll custom-draw per-segment below
          borderColor: 'rgba(0,0,0,0)',
          type: 'line',
          // Allow the visual line to be continuous across null points;
          // the actual segment rendering is handled in afterDatasetDraw.
          spanGaps: true,
          pointRadius: self.pointRadius,
          pointStyle: 'circle',
          pointBackgroundColor: colorPerPoint,
          pointBorderColor: colorPerPoint,
          pointHoverBackgroundColor: self.colorHover[j],
          pointHoverBorderColor: self.colorHover[j],
          pointHoverRadius: Math.max(self.pointRadius + 2, 4),
          borderWidth: 3,
          lineTension: 0.2
        })

        const years = (self.xAxisType === 'linear')
          ? (Array.isArray(self.xparse[j]) ? self.xparse[j] : [])
          : (Array.isArray(self.labels) ? self.labels : [])
        const values = (self.xAxisType === 'linear')
          ? djNormalized.map(p => (p && p.y !== undefined) ? p.y : null)
          : djNormalized
        if (self.hasTarget) {
          const externalTrend = Array.isArray(self.overlayTrendBySeries)
            ? self.overlayTrendBySeries[j]
            : null
          self.trendBySeries[j] = externalTrend || self.computeTrendSeriesForIndex(j, years, values, alphaByIndex)
        } else {
          self.trendBySeries[j] = null
        }
      })
    },
    createChart () {
      Chart.defaults.global.defaultFontFamily = 'Marianne'
      Chart.defaults.global.defaultFontSize = 12
      Chart.defaults.global.defaultLineHeight = 1.66
      Chart.defaults.global.defaultFontColor = '#3a3a3a'

      this.getData()
      const self = this
      const ctx = document.getElementById(self.chartId).getContext('2d')
      this.chart = new Chart(ctx, {
        data: {
          labels: self.labels,
          datasets: self.datasets
        },
        plugins: [{
          afterLayout: function (chart) {
            const ca = chart.chartArea
            if (ca && typeof ca.left === 'number' && !isNaN(ca.left)) {
              self.legendLeftMargin = Math.max(0, Math.round(ca.left))
            }
          }
        }, {
          afterDatasetDraw: function (chart, args, options) {
            if (self.vlineParse !== undefined) {
              self.vlineParse.forEach(function (line, j) {
                const ctx = chart.ctx
                const xAxis = chart.scales['x-axis-0']
                const yAxis = chart.scales['y-axis-0']

                const x = xAxis.getPixelForValue(line)

                ctx.beginPath()
                ctx.moveTo(x, yAxis.bottom)
                ctx.strokeStyle = self.vlineColorParse[j]
                ctx.lineWidth = '3'
                ctx.setLineDash([10, 5])
                ctx.lineTo(x, yAxis.top)
                ctx.stroke()
              })
            }
            if (self.hlineParse !== undefined) {
              self.hlineParse.forEach(function (line, j) {
                const ctx = chart.ctx
                const xAxis = chart.scales['x-axis-0']
                const yAxis = chart.scales['y-axis-0']
                const y = yAxis.getPixelForValue(line)

                ctx.beginPath()
                ctx.moveTo(xAxis.left, y)
                ctx.strokeStyle = self.hlineColorParse[j]
                ctx.lineWidth = '3'
                ctx.setLineDash([10, 5])
                ctx.lineTo(xAxis.right, y)
                ctx.stroke()
              })
            }
          }
        },
        {
          // Custom per-segment line drawing that:
          // - skips null / missing points
          // - connects the last valid point to the next valid one (even if there are gaps in between)
          // - draws ONLY between measured points (alpha >= 1)
          // - draws a dashed trend line instead of linking to targets/projections
          afterDatasetDraw: function (chart, args, options) {
            const dsIndex = args.index
            if (!self.showLine[dsIndex]) return
            const meta = chart.getDatasetMeta(dsIndex)
            const points = meta.data || []
            if (!points || points.length < 2) return

            const ctx = chart.ctx
            ctx.save()
            ctx.lineWidth = (chart.config.data.datasets[dsIndex].borderWidth) || 3
            ctx.lineJoin = 'round'
            ctx.lineCap = 'round'

            let lastValid = null
            for (let i = 0; i < points.length; i++) {
              const view = points[i] && points[i]._view
              if (!view || view.y === null || Number.isNaN(view.y)) {
                // Missing point: break the segment, wait for the next valid one
                continue
              }

              // Determine alpha from the current point index i
              let alpha = self.getExtrapolationAlpha()
              try {
                if (Array.isArray(self.pointOpacityParse)) {
                  if (Array.isArray(self.pointOpacityParse[0])) {
                    alpha = (self.pointOpacityParse[dsIndex] && self.pointOpacityParse[dsIndex][i] !== undefined)
                      ? self.pointOpacityParse[dsIndex][i]
                      : self.getExtrapolationAlpha()
                  } else {
                    alpha = (self.pointOpacityParse[i] !== undefined) ? self.pointOpacityParse[i] : self.getExtrapolationAlpha()
                  }
                }
              } catch (e) {
                alpha = self.getExtrapolationAlpha()
              }

              // Non-measured point => stop line, no segment toward projection/cible
              if (Number(alpha) < 1) {
                lastValid = null
                continue
              }

              if (lastValid) {
                ctx.strokeStyle = self.hexToRgba(self.colorParse[dsIndex], 1)
                ctx.setLineDash([])
                ctx.beginPath()
                ctx.moveTo(lastValid.x, lastValid.y)
                ctx.lineTo(view.x, view.y)
                ctx.stroke()
              }

              // Update last valid measured point
              lastValid = view
            }

            // Draw trend for this series (dashed, same color)
            if (self.hasTarget !== true) {
              ctx.restore()
              return
            }
            const trend = Array.isArray(self.trendBySeries) ? self.trendBySeries[dsIndex] : null
            if (Array.isArray(trend) && trend.length >= 2) {
              const xAxis = chart.scales['x-axis-0']
              const yAxis = chart.scales['y-axis-0']
              ctx.save()
              ctx.strokeStyle = self.hexToRgba(self.colorParse[dsIndex], 0.9)
              ctx.lineWidth = 2
              ctx.setLineDash([6, 4])
              ctx.beginPath()
              let moved = false
              for (let i = 0; i < trend.length; i++) {
                const yVal = trend[i]
                if (yVal === null || yVal === undefined || Number.isNaN(yVal)) continue
                const xVal = (self.xAxisType === 'linear')
                  ? (Array.isArray(self.xparse[dsIndex]) ? self.xparse[dsIndex][i] : null)
                  : (Array.isArray(self.labels) ? self.labels[i] : null)
                if (xVal === null || xVal === undefined) continue
                const x = xAxis.getPixelForValue(xVal)
                const y = yAxis.getPixelForValue(yVal)
                if (!moved) {
                  ctx.moveTo(x, y)
                  moved = true
                } else {
                  ctx.lineTo(x, y)
                }
              }
              if (moved) ctx.stroke()
              ctx.restore()
            }
            ctx.restore()
          }
        },
        {
          afterDraw: function (chart, args, options) {
            if (chart.tooltip._active !== undefined) {
              if (chart.tooltip._active.length !== 0) {
                const x = chart.tooltip._active[0]._model.x
                let y
                const index = chart.tooltip._active[0]._index
                const yAxis = chart.scales['y-axis-0']
                const xAxis = chart.scales['x-axis-0']
                const ctx = chart.ctx
                ctx.save()
                ctx.beginPath()
                ctx.moveTo(x, yAxis.top)
                ctx.lineTo(x, yAxis.bottom)
                ctx.lineWidth = '1'
                ctx.strokeStyle = self.colorPrecisionBar
                ctx.setLineDash([10, 5])
                ctx.stroke()
                ctx.restore()

                self.yparse.forEach(function (yj, j) {
                  const v = yj[index]
                  if (v === null || v === undefined || Number.isNaN(v)) return
                  y = yAxis.getPixelForValue(v)
                  ctx.save()
                  ctx.beginPath()
                  ctx.moveTo(xAxis.left, y)
                  ctx.lineTo(xAxis.right, y)
                  ctx.lineWidth = '1'
                  ctx.strokeStyle = self.colorPrecisionBar
                  ctx.setLineDash([10, 5])
                  ctx.stroke()
                  ctx.restore()
                })
              }
            }
          }
        }],
        options: {
          aspectRatio: this.aspectratio,
          animation: {
            easing: 'easeInOutBack',
            duration: 1000
          },
          scales: {
            xAxes: [{
              type: self.xAxisType,
              gridLines: {
                zeroLineColor: '#DDDDDD',
                drawOnChartArea: false,
                color: '#DDDDDD',
                lineWidth: 1
              },
              ticks: {
                display: true,
                fontColor: '#161616',
                fontSize: self.axisFontSize,
                maxRotation: self.effectiveIsSmall ? 0 : 45,
                minRotation: self.effectiveIsSmall ? 0 : 0,
                autoSkip: false,
                callback: self.chartXAxisTickCallback(self.labels.length)
              }
            }],
            yAxes: [{
              gridLines: {
                drawTicks: false,
                zeroLineColor: '#DDDDDD',
                color: '#DDDDDD',
                borderDash: [3],
                lineWidth: 1
              },
              ticks: {
                padding: 8,
                autoSkip: true,
                maxTicksLimit: 5,
                suggestedMin: 0,
                suggestedMax: self.ymax,
                fontColor: '#161616',
                fontSize: self.axisFontSize,
                callback: function (value) {
                  return self.formatChartAxisTick(value)
                }
              }
            }]
          },
          legend: {
            display: false
          },
          tooltips: {
            enabled: false,
            displayColors: false,
            backgroundColor: '#6b6b6b',
            callbacks: {
              label: function (tooltipItems) {
                const label = []
                self.datasets.forEach(function (set, i) {
                  if (self.showLine[i]) {
                    if (self.xAxisType === 'linear') {
                      const index = self.xparse[i].indexOf(tooltipItems.xLabel)
                      if (index !== -1) {
                        const v = self.yparse[i][index]
                        label.push((v === null || v === undefined || Number.isNaN(v)) ? undefined : v)
                      } else {
                        label.push(undefined)
                      }
                    } else {
                      const v = set.data[tooltipItems.index]
                      label.push((v === null || v === undefined || Number.isNaN(v)) ? undefined : v)
                    }
                  }
                })
                return label
              },
              title: function (tooltipItems) {
                return tooltipItems[0].label
              },
              labelTextColor: function (tooltipItems) {
                const colors = []
                self.showLine.forEach(function (show, i) {
                  if (show) {
                    colors.push(self.colorParse[i])
                  }
                })
                return colors
              }
            },
            custom: function (context) {
              // Tooltip Element
              const tooltipEl = self.$el.querySelector('.linechart_tooltip')

              // Hide if no tooltip
              const tooltipModel = context
              if (tooltipModel.opacity === 0) {
                tooltipEl.style.opacity = 0
                return
              }

              // Set caret Position
              tooltipEl.classList.remove('above', 'below', 'no-transform')
              if (tooltipModel.yAlign) {
                tooltipEl.classList.add(tooltipModel.yAlign)
              } else {
                tooltipEl.classList.add('no-transform')
              }

              function getBody (bodyItem) {
                return bodyItem.lines
              }
              // Set Text
              if (tooltipModel.body) {
                const titleLines = tooltipModel.title || []
                const bodyLines = tooltipModel.body.map(getBody)

                const divDate = self.$el.querySelector('.tooltip_header')
                divDate.innerHTML = titleLines[0]

                const color = tooltipModel.labelTextColors[0]
                const divValue = self.$el.querySelector('.tooltip_value')

                const nodeName = self.$el.querySelector('.tooltip_dot').attributes[0].nodeName
                divValue.innerHTML = ''
                bodyLines[0].forEach(function (line, i) {
                  if (line !== undefined && line !== null && !Number.isNaN(line)) {
                    const seriesLabel = (self.nameParse && self.nameParse[i]) ? self.capitalize(self.nameParse[i]) : ''
                    const labelText = seriesLabel ? seriesLabel : ''
                    // Order: color dot – value – label
                    divValue.innerHTML +=
                      '<span ' + nodeName + '= "" class="tooltip_dot" style="background-color:' + color[i] + '"></span>' +
                      ' ' + line +
                      (labelText ? ' – ' + labelText : '') +
                      '<br>'
                  }
                })
              }

              const {
                offsetLeft: positionX,
                offsetTop: positionY
              } = self.chart.canvas

              const canvasWidth = Number(self.chart.canvas.style.width.replace(/\D/g, ''))
              const canvasHeight = Number(self.chart.canvas.style.height.replace(/\D/g, ''))
              tooltipEl.style.position = 'absolute'
              tooltipEl.style.padding = tooltipModel.padding + 'px ' + tooltipModel.padding + 'px'
              tooltipEl.style.pointerEvents = 'none'
              let tooltipX = positionX + tooltipModel.caretX + 10
              let tooltipY = positionY + tooltipModel.caretY - 18
              if (tooltipX + tooltipEl.clientWidth + self.legendLeftMargin > positionX + canvasWidth) { // tooltip disappears at the right of the canvas
                tooltipX = positionX + tooltipModel.caretX - tooltipEl.clientWidth - 10
              }
              if (tooltipY + tooltipEl.clientHeight > positionY + 0.9 * canvasHeight) { // tooltip disappears at the bottom of the canvas
                tooltipY = positionY + tooltipModel.caretY - tooltipEl.clientHeight + 18
              }
              if (tooltipX < positionX) {
                tooltipX = positionX + tooltipModel.caretX - tooltipEl.clientWidth / 2
                tooltipY = positionY + tooltipModel.caretY - tooltipEl.clientHeight - 18
              }
              tooltipEl.style.left = tooltipX + 'px'
              tooltipEl.style.top = tooltipY + 'px'
              tooltipEl.style.opacity = 1
            }
          }
        }
      })
    },
    ChangeShowLine (index) {
      const self = this
      this.showLine[index] = !this.showLine[index]
      this.chart.data.datasets[index].showLine = this.showLine[index]
      this.opacity.length = 0
      this.showLine.forEach(function (show, j) {
        if (show) {
          self.opacity.push(1)
        } else {
          self.opacity.push(0.3)
        }
      })
      this.chart.update(0)
    },
    loadColors () {
      this.colorParse = []
      this.colorHover = []
      for (let i = 0; i < this.yparse.length; i++) {
        if (this.tmpColorParse[i] !== undefined) {
          this.colorParse.push(this.getHexaFromName(this.tmpColorParse[i]))
          this.colorHover.push(this.getHexaFromName(this.tmpColorParse[i], { hover: true }))
        } else {
          this.colorParse.push(this.getHexaFromName(this.listColors[i]))
          this.colorHover.push(this.getHexaFromName(this.listColors[i], { hover: true }))
        }
      }

      this.vlineColorParse = []
      for (let i = 0; i < this.vlineParse.length; i++) {
        if (this.tmpVlineColorParse[i] !== undefined) {
          this.vlineColorParse.push(this.getHexaFromName(this.tmpVlineColorParse[i]))
        } else {
          const vTok = resolvePrimaryBarToken(getFallbackPrimaryBarToken())
          this.vlineColorParse.push(this.getHexaFromName(vTok))
        }
      }

      this.hlineColorParse = []
      for (let i = 0; i < this.hlineParse.length; i++) {
        if (this.tmpHlineColorParse[i] !== undefined) {
          this.hlineColorParse.push(this.getHexaFromName(this.tmpHlineColorParse[i]))
        } else {
          this.hlineColorParse.push(this.getHexaFromName('beige-gris-galet'))
        }
      }
    },
    changeColors (theme) {
      const effectiveTheme = theme || 'light'
      const fontColor = this.getHexaFromToken('text-mention-grey', effectiveTheme) || '#161616'
      Chart.defaults.global.defaultFontColor = fontColor
      this.chart.options.scales.xAxes[0].gridLines.color = this.getHexaFromToken('border-default-grey', effectiveTheme)
      this.chart.options.scales.xAxes[0].gridLines.zeroLineColor = this.getHexaFromToken('border-default-grey', effectiveTheme)
      this.chart.options.scales.xAxes[0].ticks.fontColor = fontColor

      this.chart.options.scales.yAxes[0].gridLines.color = this.getHexaFromToken('border-default-grey', effectiveTheme)
      this.chart.options.scales.yAxes[0].gridLines.zeroLineColor = this.getHexaFromToken('border-default-grey', effectiveTheme)
      this.chart.options.scales.yAxes[0].ticks.fontColor = fontColor

      this.loadColors()
      if (theme === 'light') {
        this.colorPrecisionBar = '#161616'
      } else {
        this.colorPrecisionBar = '#FFFFFF'
      }
      for (let i = 0; i < this.yparse.length; i++) {
        const dataForDataset = this.chart.data.datasets[i].data || []
        const extrapolationAlpha = this.getExtrapolationAlpha()
        const colorPerPoint = dataForDataset.map((_, idx) => {
          let alpha = extrapolationAlpha
          if (Array.isArray(this.pointOpacityParse)) {
            if (Array.isArray(this.pointOpacityParse[0])) {
              alpha = (this.pointOpacityParse[i] && this.pointOpacityParse[i][idx] !== undefined) ? this.pointOpacityParse[i][idx] : extrapolationAlpha
            } else {
              alpha = (this.pointOpacityParse[idx] !== undefined) ? this.pointOpacityParse[idx] : extrapolationAlpha
            }
          }
        
          return this.hexToRgba(this.colorParse[i], alpha)
        })
        // Keep the dataset stroke invisible; custom plugin draws per-segment lines
        this.chart.data.datasets[i].borderColor = 'rgba(0,0,0,0)'
        this.chart.data.datasets[i].pointBackgroundColor = colorPerPoint
        this.chart.data.datasets[i].pointBorderColor = colorPerPoint
        this.chart.data.datasets[i].pointHoverBackgroundColor = this.colorHover[i]
        this.chart.data.datasets[i].pointHoverBorderColor = this.colorHover[i]
      }
      this.chart.update(0)
    }
  },
  created () {
    this.chartId = 'myChart' + Math.floor(Math.random() * (1000))
    this.widgetId = 'widget' + Math.floor(Math.random() * (1000))
  },
  mounted () {
    document.getElementById(this.widgetId).offsetWidth > 486 ? this.display = 'big' : this.display = 'small'
    this.viewportSmall = document.documentElement.clientWidth < 767
    this.createChart()
    const element = document.documentElement // Reference à l'element <html> du DOM
    element.addEventListener('dsfr.theme', (e) => {
      this.changeColors(e.detail.theme)
    })
    addEventListener('resize', (event) => {
      this.viewportSmall = document.documentElement.clientWidth < 767
    })
  },
  beforeUpdate () {
    this.resetData()
    this.createChart()
    const element = document.documentElement
    this.changeColors(element.getAttribute('data-fr-theme'))
  }
}
</script>
<style scoped lang="scss">
.widget_container {
  .ml-lg {
    margin-left: 0;
  }
  @media (min-width: 62em) {
    .ml-lg {
      margin-left: 3rem;
    }
  }
  .r_col {
    align-self: center;
    .flex {
      display: flex;
      .legende_dot {
        min-width: 0.8rem;
        width: 0.8rem;
        height: 0.8rem;
        min-width: 0.8rem;
        background-color: #000091;
        display: inline-block;
        margin-top: 0.25rem;
        margin-left: 0;
      }
      .legende_dash_line1{
        min-width: 0.35rem;
        width: 0.35rem;
        height: 0.2rem;
        border-radius: 0%;
        display: inline-block;
        margin-top: 0.6rem;
      }
      .legende_dash_line2{
        min-width: 0.35rem;
        width: 0.35rem;
        height: 0.2rem;
        border-radius: 0%;
        display: inline-block;
        margin-top: 0.6rem;
        margin-left: 0.1rem;
      }
    }
    
    .legend-row {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 0.65rem 1.5rem;
      padding-bottom: 0.125rem;

      .legend-item {
        cursor: pointer;
      }
    }
  }
  
  .chart canvas {
    max-width: 100%;
  }
  .linechart_tooltip {
    opacity: 0;
    width: 14rem;
    height: auto;
    background-color: white;
    position: fixed;
    z-index: 999;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 18, 0.16);
    text-align: left;
    pointer-events: none;
    font-size: 0.75rem;
    .tooltip_header {
      width: 100%;
      height: 1.75rem;
      background-color: #f6f6f6;
      color: #6b6b6b;
      padding-left: 0.75rem;
      padding-top: 0.25rem;
      padding-bottom: 0.25rem;
    }
    .tooltip_body {
      padding-left: 0.75rem;
      padding-right: 0.75rem;
      padding-top:0.25rem;
      line-height: 1.67;
      .tooltip_dot {
        min-width: 0.7rem;
        width: 0.7rem;
        height: 0.7rem;
        background-color: #000091;
        display: inline-block;
        margin-top: 0.25rem;
        margin-right: 0.25rem;
      }
      .tooltip_place {
        color: #242424;
      }
      .tooltip_value {
        color: #242424;
        font-weight: bold;
      }
    }
  }
}
</style>
